import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import config from "../../config";

const fetchOrderInvoice = (orderId) => {
    const params = {
        form_name: `payment-order`,
        doc_name: orderId,
    };
    return axios.post(
        `method/frappe_helper.frappe_helper.doctype.desk_form.desk_form.get_form_data`,
        params
    );
};

export const useOrderInvoiceData = (orderId, onSuccess, onError) => {
    return useQuery(
        ["OrderInvoiceData", orderId],
        async () => {
            const { data } = await fetchOrderInvoice(orderId);
            return data.message;
        },
        {
            enabled: !!orderId,
        }
    );
};

const createOrderInvoice = (orderId, formData) => {
    const params = {
        model: `Table Order`,
        name: orderId,
        method: `make_invoice`,
        args: JSON.stringify(formData),
    };
    try {
        return axios.post(`method/frappe_helper.api.call`, params);
    } catch (err) {
        throw new err();
    }
};

export const useCrateOrderInvoice = () => {
    const queryClient = useQueryClient();
    return useMutation(
        async ({ orderId, formData, floorName }) => {
            const data = await createOrderInvoice(orderId, formData);
            return data;
        },
        {
            onSettled: (data, error, variables, context) => {
                const { orderId, floorName } = variables;
                queryClient.invalidateQueries([
                    "getFloorFullDetails",
                    floorName,
                ]);
                queryClient.invalidateQueries(["getTableOrderItems", orderId]);
            },
        }
    );
};

const fetchInvoicePrintData = (invoiceId) => {
    let token = localStorage.getItem("accessToken");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const params = new URLSearchParams({
        model: "POS Invoice",
        doctype: "POS Invoice",
        name: invoiceId,
        no_letterhead: 1,
        letterhead: "No Letterhead",
        settings: JSON.stringify({}),
        format: "POS Invoice",
        _lang: "en",
    });

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
    };

    const backUrl = config.baseUrl;
    const url = `${backUrl}/api/method/frappe.utils.print_format.download_pdf?${params}`;

    try {
        return fetch(url, requestOptions);
    } catch (err) {
        throw err;
    }
};

export const useOrderInvoicePrintData = (invoiceId, onSuccess, onError) => {
    const queryClient = useQueryClient();

    return useQuery(
        ["OrderInvoicePrintData", invoiceId],
        async () => {
            const response = await fetchInvoicePrintData(invoiceId);
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        },
        {
            onSuccess: (data) => {
                queryClient.refetchQueries(["OrderInvoiceData", invoiceId]);

                if (onSuccess) onSuccess();
            },
            refetchOnmount: true,
            onError,
            enabled: !!invoiceId,
        }
    );
};


const fetchTodayClosedInvoices = () => {
    const params = {
        fields: JSON.stringify(["*"]),
        filters: JSON.stringify([["posting_date", "Timespan", "Today"]]),
        limit: 0, // Set the limit to 0 to load all items
    };

    return axios.get(`/resource/POS Invoice`, { params });
};

export const useTodayClosedInvoices = (onSuccess, onError) => {
    return useQuery(
        ["getTodayClosedInvoices"],
        async () => {
            const data = await fetchTodayClosedInvoices();
            return data.data.data;
        },
        {
            onSuccess,
            onError,
            cacheTime: 30 * 1000 * 60 * 60 * 24,
        }
    );
};
